import { Tooltip } from 'antd';
import FiguresTooltip from '../FiguresTooltip';
import { useCallback } from 'react';
import { enhanceColor } from '../utils';
import { useId } from 'react'

const regimeTitleHeight = 20;

export const Rect = props => {
    const { research, minDepth, scale, regimeWidth, left, date, toDepth } = props;
    const { title, fillPercent, filter_color, isInflow, inflow_character, debit } = research;

    const bottom = toDepth(research.bottom);
    const roof = toDepth(research.roof);

    const calculateFontSize = useCallback(() => {
        if (regimeWidth < 25) {
            return 10;
        }
        if (regimeWidth < 30) {
            return 11;
        }
        return 14;
    }, [regimeWidth]);

    const gradientId = useId();

    return (
        <Tooltip
            title={
                <FiguresTooltip
                    title={'Интервал'}
                    roof={roof}
                    bottom={bottom}
                    type={'filtration'}
                    inflowCharacter={inflow_character}
                    inFlow={isInflow}
                    flowRate={fillPercent}
                    date={date}
                    debit={debit}
                />
            }
            styles={{ root: { maxWidth: 'none' } }}
        >
            <svg
                data-filter_color={filter_color}
                data-title={`Интервал ${title}`}
                data-fillpercent={fillPercent ?? 'nill'}
                width={`${regimeWidth}px`}
                height={(bottom - roof) * 16}
                style={{
                    position: 'absolute',
                    left: left,
                    /*
                        Эти расчеты не очень точно позиционировали фигуру.
                        Пока оставлю, ведь в этом была какая то идея.
                    */
                    // transform: `translateY(${Math.abs((minDepth - roof) * scale - scale + regimeTitleHeight)}px)`,
                    transform: `translateY(${Math.abs((minDepth - roof - 1) * scale)}px)`,
                }}
            >
                <defs>
                    <pattern id={gradientId} patternUnits="userSpaceOnUse" width="4" height="4" patternTransform="rotate(45)">
                        <line x1="0" y1="0" x2="0" y2="4" stroke={filter_color} strokeWidth="2" />
                    </pattern>
                </defs>
                <rect
                    data-bg
                    width={`${regimeWidth}px`}
                    height={`${(bottom - roof) * 16}`}
                    rx="1"
                    fill="white"
                />
                <rect
                    data-fill-percent
                    width={fillPercent ? (`${regimeWidth}` / 100) * fillPercent : regimeWidth / 2}
                    height={`${(bottom - roof) * 16}`}
                    rx="1"
                    fill={fillPercent ? filter_color : `url(#${gradientId})`}
                    opacity={1}
                />
                <line
                    x1={fillPercent ? (`${regimeWidth}` / 100) * fillPercent : regimeWidth / 2}
                    y1={0}
                    x2={fillPercent ? (`${regimeWidth}` / 100) * fillPercent : regimeWidth / 2}
                    y2={(bottom - roof) * 16}
                    stroke={enhanceColor(filter_color)}
                    strokeWidth={1}
                />
                <rect
                    data-container-border
                    width={`${regimeWidth}px`}
                    height={`${(bottom - roof) * 16}`}
                    rx="1"
                    fill="none"
                    stroke={enhanceColor(filter_color)}
                    strokeWidth="3"
                />
                <path fill={enhanceColor(filter_color)} />
                {fillPercent ? (
                    <text
                        data-fill-percent
                        x="50%"
                        y="50%"
                        style={{
                            dominantBaseline: 'middle',
                            fill: enhanceColor(filter_color),
                            textAnchor: 'middle',
                            fontSize: calculateFontSize(),
                        }}
                    >
                        {fillPercent}
                    </text>
                ) : (
                    <text y={'50%'} x={'5px'} style={{ dominantBaseline: 'middle', fontSize: calculateFontSize(), fill: 'red' }}>
                        ---
                    </text>
                )}
            </svg>
        </Tooltip>
    );
};

const RegimeTitle = props => {
    const { regimeIdx, regimeWidth } = props;

    return (
        <div
            style={{
                width: `${regimeWidth}px`,
                height: `${regimeTitleHeight}px`,
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
            }}
            className="border-b border-gray-600 last:border-r dark:border-fill-senary/30"
        >
            <span className="text-black dark:text-font-tertiary">{`р${+regimeIdx + 1}`}</span>
        </div>
    );
};

/*
    Сейчас не используется (14.07.22)
    Причина: изменилась структура и верстка колонок, куда рисуются эти Rect.
*/
const Filtration = props => {
    const { researches, minDepth, scale, regimes, date, width, toDepth } = props;

    const regimeWidth = regimes.length > 1 ? width * 0.9 : width * 1.8;

    const regimesIdx = Object.assign({}, [...new Set(researches.map(research => research.regime))]);

    return (
        <>
            <div className="sticky top-0 flex">
                {Object.keys(regimesIdx).map(it => {
                    return <RegimeTitle key={it} regimeIdx={it} regimeWidth={regimeWidth} />;
                })}
            </div>

            {researches.map((research, idx) => {
                const regimeIdx = Object.entries(regimesIdx).find(([_, value]) => value === research.regime)[0];
                const left = 1 + regimeIdx * regimeWidth;

                return (
                    <Rect
                        key={idx}
                        research={research}
                        minDepth={minDepth}
                        scale={scale}
                        regimeWidth={regimeWidth}
                        left={left}
                        date={date}
                        toDepth={toDepth}
                    />
                );
            })}
        </>
    );
};

export default Filtration;
